// extracted by mini-css-extract-plugin
export default {"sup":"APPText_sup__rvxRv"};